import React from "react";
import {
  Grid,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Box,
  useMediaQuery,
} from "@material-ui/core";
import AdjustIcon from "@material-ui/icons/Adjust";
import BUEProduction from "../../Assets/BUE-ProductionUnit.png";
import sumergeLogo from "../../Assets/sumergeLogo.png";
import XMLogo from "../../Assets/XMLogo.png";

const steps = [
  {
    job: "junior software engineer",
    date: "[ Currently working here ]",
    label: "XM",
    img: XMLogo,
    description: `XM is a Fin-Tech company, where I develop high performance front-end app using angular and other technologies.`,
  },
  {
    job: "Associate software Engineer",
    date: "[ 03/22 - 07/23 ]",
    label: "Sumerge",
    img: sumergeLogo,
    description: `Developing high performance front-end and back-end applications using different technologies.`,
  },
  {
    job: "Frontend Intern",
    date: "[ 10/20 - 02/21 ]",
    label: "BUE Software Production Unit",
    img: BUEProduction,
    description: `Learnt how to build responsive web applications using react
    & MaterialUI. Built some projects that they used live, Also helped them in 
    making some components for their HRM web application.`,
  },
];

export default function WorkExpStepper() {
  const isSamll = useMediaQuery("(min-width:900px)");
  const isSamllXs = useMediaQuery("(min-width:600px)");
  return (
    <Stepper orientation="vertical" style={{ backgroundColor: "inherit" }}>
      {steps.map((step) => (
        <Step key={step.label} active={true} style={{}}>
          {step.label === " " ? null : (
            <StepLabel icon={<AdjustIcon color="secondary" />}>
              <span className="weSpan">{step.job}</span>
              <br />
            </StepLabel>
          )}

          <StepContent
            style={{ paddingTop: "8px", borderLeft: "1px solid #ffffffa6" }}
          >
            <Grid item md={12} sm={12} xs={12} style={{ alignSelf: "center" }}>
              <span className="date">{step.date}</span>
            </Grid>
            <Grid container spacing={0}>
              <Grid
                item
                md={12}
                sm={12}
                xs={12}
                style={{ alignSelf: "center" }}
              >
                <span className="weStepLabel">{step.label}</span>
              </Grid>
              <Box
                component="img"
                src={step.img}
                alt="company-img"
                style={{
                  margin: "0.5rem auto",
                  width: isSamll ? "25%" : isSamllXs ? "50%" : "70%",
                  minWidth: "5rem",
                  height: isSamllXs? "9rem":"6rem",
                  objectFit: "contain",
                }}
              />
              <Grid
                item
                md={12}
                sm={12}
                xs={12}
                style={{ alignSelf: "center" }}
              >
                <Typography className="steps">{step.description}</Typography>
              </Grid>
            </Grid>
            {/*{steps.indexOf(step) >= steps.length - 2 ? null : (
              <Grid item md={12} sm={12} xs={12} style={{ paddingTop: "1vh" }}>
                <ArrowDownwardIcon color="secondary" className="weicoupdown" />
              </Grid>
            )}*/}
          </StepContent>
        </Step>
      ))}
    </Stepper>
  );
}
